/*
 * WARNING: The code that follows may make you cry:
 *          A Safety Pig has been provided below for your benefit
 *                              _
 *      _._ _..._ .-',     _.._(`))
 *     '-. `     '  /-._.-'    ',/
 *       )         \            '.
 *      / _    _    |             \
 *     |  a    a    /              |
 *      \   .-.                     ;
 *       '-('' ).-'       ,'       ;
 *          '-;           |      .'
 *            \           \    /
 *            | 7  .__  _.-\   \
 *            | |  |  ``/  /`  /
 *           /,_|  |   /,_/   /
 *              /,_/      '`-'
 */

var initArtworksFormCounter = 0;
var onSubmitTriggered = 0;


function initArtworks() {

  function _artwork_template(options) {
    if(options.source) {
      var temp = '<div class="artwork enable-hover ';
      if(options.sellable != 1) {
        temp += 'priceless ';
      }
      temp += options.parent.toLowerCase();
      temp += '"><div class="inner"><img class="img-responsive" src="';
      temp += options.source;
      temp += '" alt="';
      temp += options.title;
      temp += '" title="';
      temp += options.title;
      temp += '" />';
      if(options.sellable == 1) {
        temp += '<div class="sale-badge"><span>';
        temp += options.sold ? 'Sold' : '4 Sale';
        temp += '</span></div>';
      }
      temp += '<div class="hover"><div class="content"><div class="title"><span>';
      temp += options.title;
      temp += '</span></div><div class="size"><span>';
      temp += options.size;
      temp += '</span></div><div class="price"><span>';
      temp += options.price;
      temp += ' &euro;';
      temp += '</span></div></div></div></div><div class="blackout"></div><div class="detail"><div class="close-modal"><button type="button" class="close"><span>&times;</span></button></div><div class="image"><img class="img-responsive" src="';
      temp += options.source;
      temp += '" alt="';
      temp += options.title;
      temp += '" title="';
      temp += options.title;
      temp += '" /></div><div class="main-info"><div class="title"><span class="title-value">';
      temp += options.title;
      temp += '</span> (<span class="year-value">';
      temp += options.year;
      temp += '</span>)</div><div class="size"><span class="size-value">';
      temp += options.size;
      temp += '</span></div><div class="type"><span class="type-value">';
      temp += options.type;
      temp += '</span></div><div class="tags"><span class="tags-value">';
      temp += options.tags;
      temp += '</span></div><div class="price"><span class="price-value">';
      temp += options.price;
      temp += ' &euro;';
      temp += '</span></div></div><div class="expand"><span class="expand-label">Go for it</span><span class="fa fa-angle-double-down"></span></div>';
      if(options.sellable == 1) {
        temp += '<div class="request-form"><div class="intro-text"><span class="label">I want to purchase this item for</span><span class="price">';
        temp += options.price;
        temp += ' &euro;</span><span class="label">Please contact me!</span></div>';
        temp += options.requestForm;
        temp += '<div class="outro-text"><span class="label">Please send me the purchase information!</span></div></div>';
      }
      temp += '</div></div>';

      return temp;
    } else {
      return undefined;
    }
  }
  function _button_template(title) {
    if(title) {
      title = title.split(' ').join('-');

      var temp = '<button class="filter" data-filter=".';
      temp += title.toLowerCase();
      temp += '">';
      temp += title;
      temp += '</button>';

      return temp;
    } else {
      return undefined;
    }
  }
  function initArtworksForm(ref) {
    initArtworksFormCounter++;

    var jsid = $(ref).attr('id').split('-').join('_');

    // Copied from ObisConcept.NeosAjaxForm, modified for needs
    var ajaxForm = $(ref).find('.artwork-ajax-form');

    var formIdentifier = $(ajaxForm).attr('data-identifier');
    console.log('initArtworksForm function iteration #'+initArtworksFormCounter);

    var presetName = $(ajaxForm).attr('data-preset-name');
    var dimension = $(ajaxForm).attr('data-dimension');

    var formAjaxUrl = location.protocol + '//' + location.host + '/form/'  + ( dimension != '' ? dimension + '/' : '' ) + presetName + '/' + formIdentifier;

    $(ajaxForm).on('submit', 'form', function (e) {

      var formData = new FormData(this);

      var trigger = $(ref).find('button[clicked="true"]');

      formData.append($(trigger).attr('name'), $(trigger).attr('value'));

      $.ajax({

        url: formAjaxUrl,
        type: 'POST',
        data: formData,
        mimeType: 'multipart/form-data',
        contentType: false,
        cache: false,
        processData: false,
        beforeSend: function () {

          $(ajaxForm).find('.ajax-content').replaceWith('<i class=" ajax-content fa fa-spinner fa-pulse"></i>');

        },
        success: function (data) {

          if($(data).find('form').length < 1) {
            $('.request-form').find('.intro-text, .outro-text').remove();
          }

          $(ajaxForm).find('.ajax-content').replaceWith(data);


          $(ajaxForm).find('.ajax-content').addClass('success-msg');

          $('.artwork-ajax-form button[type="submit"]').on('click', function() {
            $('.artwork-ajax-form button[type="submit"]').removeAttr('clicked');
            $(ref).attr('clicked', 'true');
          });

          initLeftCaptchas();
          console.log('AJAX Success');

        }

      });

      e.preventDefault();
      onSubmitTriggered++;
      console.log('onSubmit iteration #'+onSubmitTriggered);
    });
  }
  function initItems(ref) {
    var jsid = $(ref).attr('id').split('-').join('_');
    var items = $(ref).find('.artwork');

    items.each(function(i,e,a) {
      $(this).find('.inner').off('click').on('click',function(e) {
        $('body').css('overflow','hidden');
        $('footer').css('display','none');
        $(this).parents('.artwork').find('.blackout').fadeIn(300);
        $(this).parents('.artwork').find('.detail').fadeIn(300);
      });
      $(this).find('.detail').off('click').on('click',function(e) {
        if($(e.target).hasClass('detail')) {
          $('body').css('overflow','');
          $('footer').css('display','');
          $(this).parents('.artwork').find('.blackout').fadeOut(300);
          $(this).parents('.artwork').find('.detail').fadeOut(300);
        }
      });
      $(this).find('.detail').find('.close').off('click').on('click',function(e) {
        $('body').css('overflow','');
        $(this).parents('.artwork').find('.blackout').fadeOut(300);
        $(this).parents('.artwork').find('.detail').fadeOut(300);
      })
      $(this).find('.expand').off('click').on('click',function(e) {
        var form = $(this).parent().find('.request-form');
        if(form.hasClass('in')) {
          form.slideUp(300);
          $(this).find('.fa').removeClass('fa-angle-double-up').addClass('fa-angle-double-down');
        } else {
          form.slideDown(300);
          $(this).find('.fa').removeClass('fa-angle-double-down').addClass('fa-angle-double-up');
        }
        form.toggleClass('in');
      });
      $(this).find('.request-form').find('#artwork-request-artwork').val(window.artworksSections[jsid].data[i].title);



    });
    initArtworksForm(ref);
  }

  $('.artworks-section').each(function(index,section,array) {

    var initialSize = $(this).data('initial-size');
    var expandBy = $(this).data('expand');
    var jsid = $(this).attr('id').split('-').join('_');

    window.artworksSections[jsid].data = window.artworksSections[jsid].data.sort(function(a,b) {
      return b.year - a.year;
    });

    for (var i = 0; i < window.artworksSections[jsid].categories.length; i++) {
      $(section).find('.filter-wrapper > .filters').append(_button_template(window.artworksSections[jsid].categories[i]));
    }

    for (var i = 0; i < window.artworksSections[jsid].data.length; i++) {
      if(i < initialSize) {
        var temp = window.artworksSections[jsid].data[i];
        temp.requestForm = window.artworksSections[jsid].form;
        $(section).find('.grid').append(_artwork_template(temp));
      } else {
        break;
      }
    }

    if(initialSize >= window.artworksSections[jsid].data.length) {
      $(section).find('.loadmore').hide(0);
    }

    initItems(this);

    var iso = $(section).find('.grid').imagesLoaded(function() {
      iso.isotope({
        itemSelector: '.artwork',
        layoutMode: 'masonry',
        filter: $(section).find('.filters').find('.active').data('filter'),
        stagger: 5
      });
    });
    $(section).find('.filters').on('click','button',function(e) {
      $(this).parent().children().removeClass('active');
      $(this).addClass('active');

      var filterValue = $(this).data('filter');
      iso.isotope({
        filter: filterValue
      });
    });

    $(section).find('.loadmore').on('click','button',function(e) {
      var currentsize = $(section).find('.grid').children().length;
      var expanded = currentsize + expandBy;

      for (var i = 0; i < window.artworksSections[jsid].data.length; i++) {
        if(i < currentsize) {} else if(i >= currentsize && i < expanded) {
          var temp = window.artworksSections[jsid].data[i];
          temp.requestForm = window.artworksSections[jsid].form;

          var domelem = $(_artwork_template(temp)).addClass('newly-appended');
          iso.append(domelem);
          iso.isotope('appended',domelem);
        } else {
          break;
        }
      }

      if(expanded >= window.artworksSections[jsid].data.length) {
        $(section).find('.loadmore').hide(300);
      }

      initItems($(this).parents('.artworks-section'));

      setTimeout(function() {
        initLeftCaptchas();
        iso.isotope('layout');
      },100);
      setTimeout(function() {
        iso.isotope('layout');
      },500);
    });

    $(window).on('resize',function() {
      iso.isotope('layout');
    });
  });
}

function initLeftCaptchas() {
  $('.g-recaptcha').each(function() {
    if($(this).html() == '') {
      var key = $(this).data('sitekey');
      grecaptcha.render(this,{sitekey: key});
    }
  })
}
